import { render, staticRenderFns } from "./InstructorListAddNew.vue?vue&type=template&id=565c62f7&"
import script from "./InstructorListAddNew.vue?vue&type=script&lang=js&"
export * from "./InstructorListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./InstructorListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports